import { requirePermission } from '@/utils/auth'
import { createFileRoute, redirect } from '@tanstack/react-router'
import dayjs from 'dayjs'

export const Route = createFileRoute('/drive-statistics')({
  beforeLoad: ({ location }) => {
    requirePermission('drive_statistics')

    if (location.pathname === '/drive-statistics' || location.pathname === '/drive-statistics/') {
      const now = dayjs()
      const endDate = dayjs(now.toDate()).format('YYYY-MM-DD')
      const startDate = dayjs(now.toDate()).format('YYYY-MM-DD')

      throw redirect({
        to: '/drive-statistics/$startDate/$endDate',
        params: {
          startDate,
          endDate,
        },
      })
    }
  },
})
